export default __webpack_public_path__ + "static/media/Gráfica-1-LabNotes-Web-3.40543585.webp";